import { z } from 'zod';
import QuoteStatusPage from '@pages/QuoteStatusPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/quoteStatus')({
  component: QuoteStatusPage,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
